import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { useTranslation } from '@unifyapps/i18n/client';
import { useSnackbar } from '@unifyapps/ui/components/Snackbar';
import { isFlutterWebView, shareFileInFlutterSDK } from '../webview/SDKHandling';

export const useShareAPI = () => {
  const { showSnackbar } = useSnackbar();
  const { t } = useTranslation(['common']);

  const shareFile: typeof navigator.share = useEventCallback(
    async ({ files, title, text, url }: ShareData) => {
      // file share is not supported in flutter webview
      // only url share is supported
      // file can be shared using dataUri
      if (isFlutterWebView()) {
        if (url) {
          void shareFileInFlutterSDK(JSON.stringify({ title, text, url }));
        }
        return;
      }
      if (navigator.canShare({ files })) {
        await navigator.share({
          files,
          title,
          text,
        });
      } else {
        showSnackbar({
          title: t('common:OpenShareDialog.BrowserNotSupportWebShareAPI'),
          color: 'error',
        });
      }
    },
  );

  const shareUrl: typeof navigator.share = useEventCallback(
    async ({ url, title, text }: ShareData) => {
      if (isFlutterWebView()) {
        void shareFileInFlutterSDK(JSON.stringify({ url, title, text }));
        return;
      }

      if (navigator.canShare({ url })) {
        await navigator.share({ url, title, text });
      } else {
        showSnackbar({
          title: t('common:OpenShareDialog.BrowserNotSupportWebShareAPI'),
          color: 'error',
        });
      }
    },
  );

  return {
    shareFile,
    shareUrl,
  };
};
